import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../styles/GlobalStyle.css'
import CustomFooter from '../login/CustomFooter'
import DistrictStatsV2 from './DistrictStatsV2'
import SchoolReport from './SchoolReport'
import ColType from '../Types'
import { db, firebase } from '../firebase/Firebase'
import { getIDFromURL, flattenDoc, getQueryStringParam } from '../Util'
import { Layout, Row, Col, message, Select, Icon, Tabs } from 'antd'
import PersonAvatar from '../customcomponents/PersonAvatar'
import SchoolUploads from './SchoolUploads'
import SchoolProgressReport from './SchoolProgressReport'
import SchoolPlanningReport from './SchoolPlanningReport'
import SchoolPracticeReport from './SchoolPracticeReport'
import TeacherSummary from './TeacherSummary'
import SAMScoring from './SAMScoring'
import ProfessionalLearningReport from './ProfessionalLearningReport'
import ConsultationReport from './ConsultationReport'
import SchoolTeamworkReport from './SchoolTeamworkReport'
const { Content } = Layout
const TabPane = Tabs.TabPane

const errorMessage = (description) => {
  message.error(description)
}

class AdminHome extends Component {
  state = {
    newPopoverVisible: false,
    accountPopoverVisible: false,
    adminId: '',
    selectedId: null,
    teacherId: '',
    studentId: '',
    schoolId: '',
    teacher: null,
    student: null,
    teachers: null,
    teacherDict: null,
    students: [],
    studentDict: {},
    IEPGoals: [],
    IEPDict: {},
    calendarEvents: null,
    calendarDict: null,
    events: null,
    studentReportData: {},
    teacherTab: 'schedule',
    loadingData: false,
    loadedData: false,
    readOnly: true,
  }

  // Do fetch here
  componentDidMount() {
    document.title = 'School Reports - Dot It'

    let adminId = getIDFromURL(window.location)
    let schoolId = getQueryStringParam('s')

    this.setState({
      adminId: adminId,
      schoolId: schoolId,
    })

    this.getTeachers()
  }

  componentWillReceiveProps(nextProps) {
    this.getTeachers()
  }

  getTeachers = () => {
    let schoolId = getQueryStringParam('s')

    if (this.state.loadedData) {
      return
    }

    if (!(schoolId && this.props.adminBaseProps.admin)) {
      return
    }

    this.setState({
      loadedData: true,
    })

    db.collection(ColType.teacher)
      .where('districtId', '==', this.props.adminBaseProps.admin.districtId)
      .where('schoolIds', 'array-contains', schoolId)
      .get()
      .then((querySnapshot) => {
        var teachers = []
        var teacherDict = {}

        querySnapshot.forEach((doc) => {
          var teacher = flattenDoc(doc)
          if (!(teacher.hasOwnProperty('isVisible') && !teacher.isVisible)) {
            teachers.push(teacher)
            teacherDict[teacher.id] = teacher
          }
        })

        if (teachers.length === 0) {
          db.collection(ColType.teacher)
            .where('districtId', '==', this.props.adminBaseProps.admin.districtId)
            .where('schoolId', '==', schoolId)
            .get()
            .then((querySnapshot) => {
              var teachers = []
              var teacherDict = {}

              querySnapshot.forEach((doc) => {
                var teacher = flattenDoc(doc)
                if (!(teacher.hasOwnProperty('isVisible') && !teacher.isVisible)) {
                  teachers.push(teacher)
                  teacherDict[teacher.id] = teacher
                }
              })

              teachers.sort((a, b) => {
                if (a.lastName.charAt(0) > b.lastName.charAt(0)) {
                  return 1
                } else {
                  return -1
                }
              })

              this.setState({
                teachers: teachers,
                teacherDict: teacherDict,
                loadingData: false,
              })
            })
        } else {
          teachers.sort((a, b) => {
            if (a.lastName.charAt(0) > b.lastName.charAt(0)) {
              return 1
            } else {
              return -1
            }
          })

          this.setState({
            teachers: teachers,
            teacherDict: teacherDict,
            loadingData: false,
          })
        }
      })
  }

  newVisibleChange = (visible) => {
    this.setState({ newPopoverVisible: visible })
  }

  accountVisibleChange = (visible) => {
    this.setState({ accountPopoverVisible: visible })
  }

  signOut = () => {
    firebase.auth().signOut().then(function () {
      console.log('Signed Out')
      //sending users to the sign in page after signing out for now.
      window.location.href = "/sign-in"
    }, function (error) {
      console.error('Sign Out Error', error)
      errorMessage("There was an error signing you out. Please try again.")
    })
  }

  onChange = (value) => {
    console.log(`selected ${value}`)
  }

  onSelect = (value, option) => {
    console.log('on select', value, option)
    console.log('/teacher/student/' +
      this.props.person.id + '?student=' +
      option.key)

    this.props.history.push(
      {
        pathname: '/admin/school-summary/' +
          this.props.person.id + '?district=' +
          this.props.person.districtId + '&school=' +
          option.key
      }
    )
  }

  onSchoolOrDistrictSelect = (schoolOrDistrict) => {
    if (this.props.adminBaseProps.district &&
      this.props.adminBaseProps.district.id === schoolOrDistrict) {
      this.props.history.push(
        {
          pathname: '/admin/admin-home/' +
            this.props.adminBaseProps.admin.id
        }
      )
    }
    else {
      this.props.history.push(
        {
          pathname: '/admin/admin-home/' +
            this.props.adminBaseProps.admin.id + '?s=' + schoolOrDistrict
        }
      )
    }
  }

  teacherClick = (teacher) => {
    this.setState({
      teacher: teacher,
      teacherId: teacher.id
    })

    this.getStudents(teacher)

    window.scroll(0, 0)
  }

  studentClick = (student) => {
    this.setState({
      student: student,
      studentId: student.id,
      studentReportData: {
        teacherId: this.state.teacher.id,
        studentId: student.id,
        teacher: this.state.teacher,
        student: student,
        teachers: this.state.teachers,
        students: this.state.students,
        studentDict: this.state.studentDict,
        // goals for this student
        IEPGoals: this.state.IEPGoals.filter((e) => e.studentId === student.id),
        IEPDict: this.state.IEPDict,
      }
    })

    window.scroll(0, 0)
  }

  onSchoolOrDistrictSelect = (schoolOrDistrict) => {
    this.setState({
      selectedOptionId: schoolOrDistrict
    })

    if (this.props.adminBaseProps.district &&
      this.props.adminBaseProps.district.id === schoolOrDistrict) {
      this.props.history.push(
        {
          pathname: '/admin/admin-home/' +
            this.props.adminBaseProps.admin.id
        }
      )
    }
    else {
      this.props.history.push(
        {
          pathname: '/admin/admin-home/' +
            this.props.adminBaseProps.admin.id + '?s=' + schoolOrDistrict
        }
      )
    }
  }

  render() {
    const schoolName = this.props.adminBaseProps.admin &&
      this.props.adminBaseProps.schoolsDict &&
      this.props.adminBaseProps.schoolsDict.hasOwnProperty(this.state.schoolId) ?
      this.props.adminBaseProps.schoolsDict[this.state.schoolId].schoolName : ''
    return (
      <div>
        <div>
          <Layout className="content relative">
            <Layout >
              <Content className='layout-header-mt'>
                <div>
                  {this.state.adminId &&
                    this.props.adminBaseProps.admin &&
                    this.props.adminBaseProps.district &&
                    this.props.adminBaseProps.schoolsDict &&
                    this.props.adminBaseProps.user
                    ?
                    <div>
                      <div className="sub-menu-width-vlg m-lr-auto mt-3">
                        <div>
                          <Row gutter={32}>
                            <Col span={24}>
                              {/* Breadcrumb: District > School */}
                              <div className="w-100 flex flex-v-center mb-2" style={{ fontSize: 16 }}>
                                <Link to={'/admin/admin-home/' + this.props.adminBaseProps.admin.id}
                                  style={{ fontWeight: 700, color: '#2d6a9f' }}>
                                  {this.props.adminBaseProps.district.district}
                                </Link>
                                <Icon type="right" className="ml-1 mr-1" style={{ fontSize: 13, color: '#94a3b8' }} />
                                <span style={{ fontWeight: 700, color: '#1e293b' }}>{schoolName}</span>
                              </div>

                              {/* Gradient hero banner with the school name */}
                              <div className='br-20 overflow-hidden mb-3 mt-2'>
                                <div className='br-20 p-3'
                                  style={{ minHeight: '220px', background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)' }}>
                                  <div className='h-100'>
                                    <div className='flex flex-v-center font-40 font-fff w-100 h-100 p-4'>
                                      <div className='w-100'>
                                        <div className='font-40 font-bold font-fff'>{schoolName}</div>
                                        <div className='font-20 font-fff mt-1'>Teachers and school reports</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Friendly "what to do" banner */}
                              <div style={{ display: 'flex', gap: 16, alignItems: 'center', background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16, padding: '18px 22px', marginBottom: 22 }}>
                                <Icon type='team' style={{ fontSize: 34, color: '#2d6a9f' }} />
                                <div>
                                  <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 2 }}>Choose a teacher or open a report</div>
                                  <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.5 }}>Use the tabs below to see this school's teachers or to open its reports. Click any teacher in the list to view their details. You can also search for a teacher by name.</div>
                                </div>
                              </div>

                              <Tabs size='large' animated={false}>
                                <Tabs.TabPane tab={'Teachers'} key={'school'}>
                                  {this.state.teachers ?
                                    <div className='pl-2 pr-2 pt-4'>
                                      <Select
                                        showSearch
                                        placeholder="Search for a teacher"
                                        className='w-100 mb-2'
                                        optionFilterProp="children"
                                        onSelect={(teacherId) => {
                                          if (this.props.adminBaseProps.admin && this.state.schoolId && teacherId) {
                                            this.props.history.push({
                                              pathname: '/admin/teacher/' + this.props.adminBaseProps.admin.id + '?s=' + this.state.schoolId + '&t=' + teacherId
                                            })
                                          }
                                        }}
                                        size="large"
                                        filterOption={(input, option) => {
                                          let person = option.props.children.props.person
                                          let fullName = person.firstName + ' ' + person.lastName
                                          return fullName.toLowerCase().includes(input.toLowerCase())
                                        }}
                                      >
                                        {this.state.teachers.map((teacher, idx) => {
                                          return <Select.Option value={teacher.id} key={'search-' + teacher.id}>
                                            <PersonAvatar
                                              person={teacher}
                                              avatarColor={'#d3adf7'}
                                              avatarTextColor={'#000'}
                                              containerClassName="font-16"
                                              avatarClassName="font-16 font-bold mr-2"
                                              personClassName="font-black font-16"
                                            />
                                          </Select.Option>
                                        })}
                                      </Select>
                                    </div>
                                    : ''}
                                  {this.state.teachers && this.state.teachers.length === 0 ?
                                    <div className='pl-2 pr-2'>
                                      <div style={{ background: '#fff', border: '1px solid #e8eef5', borderRadius: 16, padding: '18px 20px', fontSize: 16, color: '#475569' }}>
                                        No teachers yet.
                                      </div>
                                    </div>
                                    : ''}
                                  {this.state.teachers &&
                                    this.state.teachers.map((teacher, idx) => {
                                      return <div className='pl-2 pr-2' key={'teacher-row-' + teacher.id}>
                                        <Link to={'/admin/teacher/' + this.props.adminBaseProps.admin.id + '?s=' + this.state.schoolId + '&t=' + teacher.id}
                                          id={'right-menu-' + teacher.id}>
                                          <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#fff', border: '1px solid #e8eef5', borderRadius: 16, padding: '16px 20px', marginBottom: 12, boxShadow: 'rgba(100, 100, 111, 0.12) 0px 4px 14px 0px' }}>
                                            <PersonAvatar
                                              person={teacher}
                                              size={'large'}
                                              avatarColor={'#d3adf7'}
                                              avatarTextColor={'#000'}
                                              containerClassName="font-20"
                                              avatarClassName="font-20 font-bold mr-1"
                                              personClassName="font-black font-20"
                                            />
                                            <TeacherSummary teacher={teacher} />
                                            <Icon type='right' style={{ marginLeft: 'auto', fontSize: 20, color: '#94a3b8' }} />
                                          </div>
                                        </Link>
                                      </div>
                                    })}
                                </Tabs.TabPane>
                                <TabPane tab="Our School Improvement Reports" key="professional-learning-reports">
                                  <div className='mt-3 pl-2 pr-2'>
                                    <ProfessionalLearningReport
                                      districtId={this.props.adminBaseProps.admin.districtId}
                                      schoolId={this.state.schoolId}
                                      personId={this.props.adminBaseProps.user.id}
                                    />
                                  </div>
                                </TabPane>
                                <TabPane tab="Coaching Reports" key="school-teamwork-reports">
                                  <div className='mt-3 pl-2 pr-2'>
                                    <SchoolTeamworkReport
                                      districtId={this.props.adminBaseProps.admin.districtId}
                                      schoolId={this.state.schoolId}
                                      personId={this.props.adminBaseProps.user.id}
                                    />
                                  </div>
                                </TabPane>
                                <TabPane tab="Consultation Reports" key="consultation-reports">
                                  <div className='mt-3 pl-2 pr-2'>
                                    <ConsultationReport
                                      districtId={this.props.adminBaseProps.admin.districtId}
                                      schoolId={this.state.schoolId}
                                      personId={this.props.adminBaseProps.user.id}
                                    />
                                  </div>
                                </TabPane>
                              </Tabs>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    : ''}
                </div>
              </Content>
            </Layout>
          </Layout>
        </div>
        <CustomFooter />
      </div>
    )
  }
}

export default AdminHome